import { useRequest, useSessionStorage } from '@/hooks';
import { stripTags } from '@/utils';
import { useConfigStore, useFormProps } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import useFeedback from '../hooks/useFeedback';
import usePages from '../hooks/usePages';

export default function usePostFeedback() {
	const { formKey, domain, feedbackDomain, disablePost, multipleIndex, getTrail } =
		useFormProps();
	const { formIsCompleted, feedbackId } = useFormStore();
	const { sendOptions, properties } = useConfigStore();
	const pages = usePages();
	const feedback = useFeedback({
		addHoney: true
	});
	const [didPost, setDidPost] = useSessionStorage(
		`${formKey}.pid.${multipleIndex ?? 0}`,
		null
	);

	const request = useRequest({
		url: `https://${feedbackDomain}/api/1/data`,
		json: true,
		spoof: disablePost,
		data: {
			survey: false,
			followup: didPost === feedbackId,
			token: sendOptions.token,
			surveyid: properties.id,
			domain,
			...(typeof getTrail === 'function' && {
				trail: getTrail()
			}),
			pages: pages?.length,
			data: feedback.map(item => {
				return {
					label: item.label ? String(item.label).replace('"', '') : '',
					value:
						item.type !== 'dom' && item.type !== 'selector'
							? stripTags(item.value)
							: item.value,
					type: item.type
				};
			})
		},
		onSuccess: response => {
			if (response.code === 200) {
				setDidPost(formIsCompleted ? null : feedbackId);
			}
		}
	});

	return request;
}
